<template>
    <div>
        <el-row type="flex" align="middle" style="margin-bottom: 16px;">
            <el-col :span="1" style="width: 80px; text-align: right; padding-right: 12px;">
                类型
            </el-col>
            <el-col :span="20">
                <el-select v-model="selectAppType" placeholder="选择应用模版类型" :disabled="disable">
                    <el-option v-for="item in appTemplateType" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="3" style="display: flex;justify-content: end;">
                <el-button @click="handletAbleShow">取消</el-button>
            </el-col>
        </el-row>
        <el-row>
            <div v-if="selectAppType == 'helm'">
                <AppHelmCreate
:marketID="marketID"
:appID="appID"
:onSuccess="onSuccess"
:editVersion="editDetail"
                    :editFun="editData" />
            </div>
            <div v-else-if="selectAppType == 'file'">
                <AppSoftwareCreate
:marketID="marketID"
:appID="appID"
:onSuccess="onSuccess"
:editVersion="editDetail"
                    :editFun="editData" />
            </div>
            <div v-else-if="selectAppType == 'docker'">
                <AppDockerCreate
:marketID="marketID"
:appID="appID"
:onSuccess="onSuccess"
:editVersion="editDetail"
                    :editFun="editData" />
            </div>
            <div v-else-if="selectAppType == 'RAM'">
                <AppRamEdit
:marketID="marketID"
:appID="appID"
:onSuccess="onSuccess"
:editVersion="editDetail"
                    :editFun="editData" />
            </div>
            <div v-else-if="selectAppType == 'dockerCompose'">
                <AppDockerComposeCreate
:marketID="marketID"
:appID="appID"
:onSuccess="onSuccess"
:editVersion="editDetail"
                    :editFun="editData" />
            </div>
        </el-row>
    </div>
</template>
<script>
import AppSoftwareCreate from './appSoftwareCreate.vue'
import AppHelmCreate from './appHelmCreate.vue'
import AppDockerCreate from './appDockerCreate.vue'
import AppDockerComposeCreate from './appDockerComposeCreate.vue'
import AppRamEdit from './editRam.vue';
import { updateAppVersion } from '@/api/app';
export default {
  name: 'AppUploadEntrance',
  components: { AppHelmCreate, AppSoftwareCreate, AppDockerCreate, AppRamEdit, AppDockerComposeCreate },
  props: {
    marketID: String,
    onSuccess: Function,
    appID: String,
    editInfo: Object,
    type: String,
    handletAbleShow: Function
  },
  data() {
    return {
      selectAppType: '',
      disable: false,
      appTemplateType: [
        {
          value: 'helm',
          label: 'Helm Chart'
        },
        {
          value: 'docker',
          label: 'Docker Image'
        },
        {
          value: 'dockerCompose',
          label: 'Docker Compose'
        },
        {
          value: 'file',
          label: '软件包'
        }
      ],
      editDetail: {}
    }
  },
  created() {
    if (this.type) {
      this.selectAppType = this.type
    } else {
      this.selectAppType = 'file'
    }
    if (Object.keys(this.editInfo).length > 0) {
      this.editDetail = this.editInfo
      this.editDetail.version = this.editInfo.appVersion
      this.editDetail.versionAlias = this.editInfo.appVersionAlias
      this.editDetail.description = this.editInfo.desc
      if (this.editInfo.arch === '') {
        this.editInfo.arch = []
      } else if (this.editInfo.arch.includes(',')) {
        const arr = this.editInfo.arch.split(',')
        this.editInfo.arch = [...new Set(arr)]
      } else {
        this.editInfo.arch = [this.editInfo.arch]
      }
      this.editDetail.arch = this.editInfo.arch
      this.disable = true
    } else {
      this.editDetail = {}
      this.disable = false
    }
  },
  mounted() {
  },
  computed: {

  },
  methods: {
    editData(value) {
      updateAppVersion({
        marketID: this.marketID,
        appID: this.appID,
        version: value.version,
        enable: value.enable,
        description: value.description,
        versionAlias: value.versionAlias,
        is_plugin: value.is_plugin,
        templateType: value.templateType,
        cmd: value.cmd || '',
        detail: value.detail,
        arch: value.arch
      })
        .then(res => {
          this.onSuccess && this.onSuccess()
          this.$message({
            message: '更新成功',
            type: 'success'
          });
        })
        .catch(err => {
          this.$message({
            message: '更新失败',
            type: 'success'
          });
          this.onSuccess && this.onSuccess()
        });
    }
  }
};
</script>
<style lang="scss" scoped ></style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appUploadEntrance.vue